/**
 * Sidebar/MenuButton/index.tsx
 * desc: a button-styled row of the v2 sidebar for actions that open something in place instead of navigating
 * note: same row anatomy as MenuItem (icon + label; collapsed rows keep the label as tooltip + accessible name)
 */

import Tooltip from '../../Tooltip/typed';
import { trackEvent } from '../../../utilities/analytics';
import { translate } from '../../../utilities/localization';
import type { NavAction } from '../config';
import { COLLAPSED_TOOLTIP_OFFSET } from '../constants';

interface MenuButtonProps {
    action: NavAction;
    isCollapsed: boolean;
    onClick: () => void;
}

const MenuButton = ({ action, isCollapsed, onClick }: MenuButtonProps) => {
    //*************************************************
    //*****   Data   **********************************
    //*************************************************
    const label = translate(action.labelKey);
    const Icon = action.icon;


    //*************************************************
    //*****   Public Functions   **********************
    //*************************************************
    const handleClick = () => {
        trackEvent(`Global: Sidebar - ${action.id} Button (Click)`);
        onClick();
    };


    //*************************************************
    //*****   Render   ********************************
    //*************************************************
    return (
        <Tooltip arrow={ false } asChild side="right" sideOffset={ COLLAPSED_TOOLTIP_OFFSET } text={ isCollapsed ? label : null }>
            <button type="button" className="row" aria-label={ isCollapsed ? label : undefined } onClick={ handleClick }>
                <Icon readOnly tooltip={ null }/>
                { !isCollapsed ? <span className="label">{ label }</span> : null }
            </button>
        </Tooltip>
    );
};

export default MenuButton;
